import React, { useMemo } from 'react';
import { observer } from 'src/utils/mobx-react';
import { BadgeBonus } from 'src/domains/common/components/badge/badge';
import { BonusWinningsModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/BonusWinningsModel';
import { useAppStateContext } from 'src/AppState/AppState';
import { BonusCardState } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/BonusCardState';
import { useCommon } from 'src/AppState/Common';
import { cn } from 'src/domains/common/components/utils';
import { BonusCardButtons } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/bonusCardButtonsHelper';
import { BonusBalanceNavigationState } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/PromotionHistoryTabs/BonusBalanceTab/BonusBalanceNavigation.state';

interface BonusCardPropsType {
    bonusWinningsModel: BonusWinningsModel;
    userId: number;
    state: BonusBalanceNavigationState;
}

export const BonusWinningsCard = observer(
    'BonusWinningsCard',
    ({ bonusWinningsModel, userId, state }: BonusCardPropsType) => {
        const common = useCommon();
        const { models } = useAppStateContext();
        const walletData = models.getUserModel(userId).walletData.data;
        const { rewardName, playthrough, bonusBalanceProgressModelWhenReady } = bonusWinningsModel;
        const bonusCardState = useMemo(() => new BonusCardState(bonusWinningsModel, common), []);

        const { bonusStatus, bonusId, getAmount } = bonusCardState;
        const isActive = bonusId === state.activeModel?.id;

        if (walletData === null) {
            return null;
        }
        return (
            <div
                className={cn(
                    'px-4 max-w-[352px] py-[12px] w-full rounded-md bg-white border border-solid border-border mb-4',
                    { 'border-primary': isActive }
                )}
            >
                <div className='flex flex-col gap-3 h-full'>
                    <div>
                        <div className=' flex gap-2 justify-between items-center capitalize'>
                            <div className='w-full'>
                                <div className='flex justify-between items-center w-full mb-4'>
                                    <div className='text-lg font-bold overflow-hidden break-all line-clamp-3'>
                                        {rewardName}
                                    </div>

                                    <BadgeBonus
                                        key={bonusId}
                                        variant={bonusStatus}
                                    />
                                </div>
                                <div className='flex flex-col gap-2'>
                                    <div className='flex justify-between  '>
                                        <p className='text-xs m-0'> Amount:</p>
                                        <p className='text-xs m-0 font-bold'>{getAmount(walletData)}</p>
                                    </div>
                                    <div className='flex justify-between'>
                                        <p className='text-xs m-0'> Playthrough:</p>
                                        <p className='text-xs m-0'>{playthrough === null ? `-` : `${playthrough}X`}</p>
                                    </div>
                                    <div className='flex justify-between'>
                                        <p className='text-xs m-0'> Progress: </p>
                                        <p className='text-xs m-0'>
                                            {bonusBalanceProgressModelWhenReady?.currentProgress.format(
                                                walletData.currency
                                            ) ?? '...'}
                                            {' of '}
                                            {bonusBalanceProgressModelWhenReady?.totalRequiredPlaythrough.format(
                                                walletData.currency
                                            ) ?? '...'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BonusCardButtons
                        model={bonusWinningsModel}
                        accountId={userId}
                        bonusCardState={bonusCardState}
                        state={state}
                    />
                </div>
            </div>
        );
    }
);
